import React from 'react';
import "./failure.css";
import Button from "../../components/button/Button";

const Failure = () => {
  return (
    <div className='failure-container'>
        <div className="button-container">
        <Button route="/" text="Inicio" />
        <Button route="/brands" text="Marcas" />
        </div>

        <p className="failure-title">Hubo un error procesando su pago... Por favor inténtelo nuevamente o póngase en contacto.</p>
    </div>
  )
}

export default Failure